import dayjs from "dayjs"
import localizedFormat from "dayjs/plugin/localizedFormat"

dayjs.extend(localizedFormat)

export const DATE_FORMAT = {
  date: "L",
  datetime: "L LT"
}

const format = {
  formatDate: (value: string) =>
    value ? dayjs(value).format(DATE_FORMAT.date) : "N/a"
}

export default format
